import { render, staticRenderFns } from "./DistributionPriceDialog.vue?vue&type=template&id=6eb97c20&scoped=true"
import script from "./DistributionPriceDialog.vue?vue&type=script&lang=js"
export * from "./DistributionPriceDialog.vue?vue&type=script&lang=js"
import style0 from "./DistributionPriceDialog.vue?vue&type=style&index=0&id=6eb97c20&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb97c20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eb97c20')) {
      api.createRecord('6eb97c20', component.options)
    } else {
      api.reload('6eb97c20', component.options)
    }
    module.hot.accept("./DistributionPriceDialog.vue?vue&type=template&id=6eb97c20&scoped=true", function () {
      api.rerender('6eb97c20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/components/DistributionPriceDialog.vue"
export default component.exports